import React, { useState } from 'react'
import CallCenterConversations from '@/pages/callcenter/Conversations'
import TeamSelectModal from '@/components/shared/TeamSelectModal'

const AdminConversations: React.FC = () => {
  const [teamId, setTeamId] = useState<number | undefined>(undefined)
  const [teamModal, setTeamModal] = useState(false)

  return (
    <div className="p-6 space-y-4">
      <div className="bg-white border border-slate-200 border-t-2 border-t-primary-600 p-4 flex items-center justify-between">
        <div className="text-sm text-slate-700">
          Seçili takım: <span className="font-medium text-slate-900">{teamId ? `ID: ${teamId}` : '—'}</span>
        </div>
        <button
          className="px-3 py-2 border border-slate-300 text-sm font-medium text-slate-700 hover:bg-slate-50"
          onClick={()=>setTeamModal(true)}
        >
          Takım Seç
        </button>
      </div>
      <CallCenterConversations teamIdOverride={teamId} requireTeamForAdmin />
      <TeamSelectModal isOpen={teamModal} onClose={()=>setTeamModal(false)} onSelect={(t)=>{ setTeamId(t.id); setTeamModal(false) }} />
    </div>
  )
}

export default AdminConversations
